jQuery(document).ready(function (e) {
  // Entferne die nojs-Class vom body-tag, wenn Javascript aktiviert ist
  jQuery("body").removeClass("nojs");
});

// Utility-Funktionen
var Util = Util || {};

Util.setSite = function (site) {

  this._site = site;

  return this;
};

Util.getSite = function () {
  return this._site;
};

Util.setLocale = function (locale) {

  this._locale = locale;

  return this;
};

Util.elemData = function (elem, name, defaultValue) {
  return 'undefined' !== typeof jQuery(elem).data(name) && jQuery(elem).data(name) || defaultValue || '';
};

Util.getDataAttributesOfObject = function (object, params) {

  for (var key in object) {
    if (typeof object[key] !== 'object') {
      params[key] = object[key];
    }
  }

  return params;
};

Util.getLocale = function () {
  return this._locale;
};

Util.ajaxParameters = {};
Util.ajaxSetParam = function (n, v) {
  this.ajaxParameters[n] = v;
};

(function ($) {

  Util.ajax = function (module, handler, params, ajax) {

    var site = 'string' === typeof this._site && this._site || '',
        locale = 'string' === typeof this._locale && this._locale || params.locale || '',
        module = 'string' === typeof module && module || '',
        handler = 'string' === typeof handler && handler || '',
        params = 'object' === $.type(params) && params || {},
        ajaxParams = {},
        ajaxSettings = 'object' === $.type(ajax) && ajax || {},
        // Callbacks
        success = function () {
        },
        jqXHR;

    // HTTP-Methode per Default "POST"
    if (false === ajaxSettings.hasOwnProperty('method')) {
      ajaxSettings.method = 'POST';
    }

    // Ajax-URL entfernen, denn der ist fix
    delete ajaxSettings.url;

    // Standardwerte fuer Parameter ggf. ueberschreiben
    $.extend(ajaxParams, this.ajaxParameters, params);

    // Ajax-Settings
    $.extend(ajaxSettings, {
      data: {
        site: site,
        lang: locale,
        module: module,
        action: handler,
        p: ajaxParams
      },
      dataType: 'json'
    });

    if ('function' === typeof ajaxSettings.success) {
      success = ajaxSettings.success;
      delete ajaxSettings.success;
    }
    else if ('function' === typeof ajaxSettings.done) {
      success = ajaxSettings.done;
      delete ajaxSettings.done;
    }

    jqXHR = $.ajax('/ajax.php', ajaxSettings);

    // Callbacks aufrufen
    jqXHR.done(success);
  };

  $(function () {
    // Set default locale for utility functions
    var locale = $('body').data('i18n-locale') || 'de_DE';
    Util.setLocale(locale);
  });

})(jQuery);

/**
 * Created by rpr on 11.11.16.
 */

var Toggle = Toggle || {};

Toggle.init = function () {
  jQuery('.toggle-item').toggleItem();
};

(function ($) {

  const GROUP_CLASS = "toggle-group";
  const SINGLE_CLASS = "toggle-single";
  const ITEM_CLASS = "toggle-item";
  const BUTTON_CLASS = ITEM_CLASS + "__button";
  const CONTENT_CLASS = ITEM_CLASS + "__content";
  const ACTIVE_STATE = "--active";


  $.widget("om.toggleItem", {

    options: {
      button: "> ." + BUTTON_CLASS, // selector for the toggle button relative
                                    // to the item or a jQuery object
      content: "> ." + CONTENT_CLASS, // selector for the toggleable content
                                      // relative to the item or a jQuery
                                      // object
      initial: false, // initial state is active if set to true or containing a
                      // selector which matches the item
      closeOnBlur: false
    },

    _create: function () {
      var item = this;
      item.element.addClass(ITEM_CLASS);
      item.button = item._getComponent(item.options.button);
      item.content = item._getComponent(item.options.content);
      item._setState(item._getInitialState());

      item.button.on('click', function (e) {
        e.preventDefault();
        item.toggle();
      });

      if (true === item.options.closeOnBlur) {
        // Close toggle item if clicked outside
        // @see
        // https://stackoverflow.com/questions/37573608/how-to-make-modal-close-on-click-outside
        $('body').on('click', function (e) {
          if (true === item.isActive()
              && 0 === $(e.target).closest(item.element).length) {
            item.deactivate();
          }
        });
      }
    },

    _getComponent: function (selectorOrObject) {
      if (selectorOrObject instanceof jQuery) {
        return selectorOrObject;
      }
      else {
        return this.element.find(selectorOrObject);
      }
    },

    _getInitialState: function () {
      if (typeof this.options.initial == 'string') {
        return this.element.is(this.options.initial);
      }
      return this.options.initial;
    },

    isActive: function () {
      return this.element.hasClass(ITEM_CLASS + ACTIVE_STATE);
    },

    _setState: function (active) {
      this.element.toggleClass(ITEM_CLASS + ACTIVE_STATE, active);
      this.button.toggleClass(BUTTON_CLASS + ACTIVE_STATE, active);
      this.content.toggleClass(CONTENT_CLASS + ACTIVE_STATE, active);
    },

    toggle: function (activate) {
      if (typeof activate === 'undefined') {
        activate = !this.isActive();
      }

      if (activate && this._trigger("beforeActivate") === false) {
        // activate canceled
        activate = false;
      }
      this._setState(activate);
    },

    activate: function () {
      this.toggle(true);
    },

    deactivate: function () {
      this.toggle(false);
    }
  });


  $.widget("om.toggleGroup", {
    options: {
      items: "> ." + ITEM_CLASS, // selector for the toggle items relative to
                                 // the group or a configuration object like {
                                 // "item-selector" : { button:
                                 // "button-selector", // selector for the
                                 // toggle button of the current toggle item
                                 // content: "content-selector", // selector
                                 // for the toggleable content of the current
                                 // toggle item scope: "body|group|item", //
                                 // determines the scope of the button and
                                 // content selectors initial:
                                 // "true|false|selector", // initial state of the current item closeOnBlur: false, // closeOnBlur setting of the current item } }
      button: "> ." + BUTTON_CLASS, // default selector for the toggle button
                                    // relative to each item in "items"
      content: "> ." + CONTENT_CLASS, // default selector for the toggleable
                                      // content relative each item in "items"
      scope: "item", // default scope of the button and content selectors of
                     // each item in "items"
      initial: false, // default initial state of each item in "items"
      closeOnBlur: false, // default closeOnBlur setting of each item in "items"
      exclusive: true // allow only one item to be active
    },

    _create: function () {
      var group = this;
      group.element.addClass(GROUP_CLASS);

      if (typeof(group.options.items) === "string") {
        var itemOptionsStub = {};
        itemOptionsStub[group.options.items] = {}; // use default options
        group.options.items = itemOptionsStub;
      }

      group.items = $();
      for (var itemSelector in group.options.items) {
        group.items = group.items.add(group.element.find(itemSelector).toggleItem({
          button: this._getItemComponent(itemSelector, "button"),
          content: this._getItemComponent(itemSelector, "content"),
          initial: this._getItemOption(itemSelector, "initial"),
          closeOnBlur: this._getItemOption(itemSelector, "closeOnBlur"),
          beforeActivate: function () {
            if (group.options.exclusive) {
              group.deactivateAll();
            }
          }
        }));
      }
    },

    _getItemOption: function (itemSelector, key) {
      if (this.options.items[itemSelector] &&
          typeof(this.options.items[itemSelector][key]) !== "undefined") {
        return this.options.items[itemSelector][key];
      }
      else {
        return this.options[key];
      }
    },

    _getItemComponent: function (itemSelector, componentKey) {
      var scope = this._getItemOption(itemSelector, "scope"),
          componentSelector = this._getItemOption(itemSelector, componentKey);
      switch (scope) {
        case "body":
          return $(componentSelector);
        case "group":
          return this.element.find(componentSelector);
        default:
          return componentSelector;
      }
    },

    deactivateAll: function () {
      this.items.toggleItem("deactivate");
    }
  });
  // Apply "Toggle item" functionality to default CSS class
  $(function () {
    Toggle.init();
  });
})(jQuery);

/**
 // https://gist.github.com/lisacatalano/7360603
 // additional inplace option for radio buttons
 List of radio buttons. Unlike checklist, value is stored internally as
 scalar variable instead of array. Extends Checklist to reuse some code.

 @class radiolist
 @extends checklist
 @final
 @example
 <a href="#" id="options" data-type="radiolist" data-pk="1" data-url="/post" data-title="Select options"></a>
 <script>
 $(function(){
    $('#options').editable({
        value: 2,
        source: [
              {value: 1, text: 'option1'},
              {value: 2, text: 'option2'},
              {value: 3, text: 'option3'}
           ]
    });
});
 </script>
 **/
( function($) {
  var Radiolist = function(options) {
    this.init('radiolist', options, Radiolist.defaults);
  };
  $.fn.editableutils.inherit(Radiolist, $.fn.editabletypes.checklist);

  $.extend(Radiolist.prototype, {
    renderList : function() {
      var $label;
      this.$tpl.empty();
      if (!$.isArray(this.sourceData)) {
        return;
      }

      // extend gist, kha [SEPKLASSIK-171]
      for (var i = 0; i < this.sourceData.length; i++) {
        $input = $('<input>', {
          type : 'radio',
          name : this.options.name,
          value : this.sourceData[i].value,
          id: 'option-'+this.sourceData[i].value
        });
        $label = $('<label>', {class: 'option__check', for: 'option-'+this.sourceData[i].value}).text(this.sourceData[i].text);
        $formElement = $('<div>', {'class': 'form__type--radio'}).append($input).append($label);
        this.$tpl.append($formElement);
      }

      this.$input = this.$tpl.find('input[type="radio"]');
    },
    input2value : function() {
      return this.$input.filter(':checked').val();
    },
    str2value: function(str) {
      return str || null;
    },

    value2input: function(value) {
      this.$input.val([value]);
    },
    value2str: function(value) {
      return value || '';
    },
  });

  Radiolist.defaults = $.extend({}, $.fn.editabletypes.list.defaults, {
    /**
     @property tpl
     @default <div></div>
     **/
    tpl : '<div class="editable-radiolist"></div>',

    /**
     @property inputclass, attached to the <label> wrapper instead of the input element
     @type string
     @default null
     **/
    inputclass : '',

    name : 'defaultname'
  });

  $.fn.editabletypes.radiolist = Radiolist;
}(window.jQuery));
(function ($, U) {
  // Do not request preview if another preview request has not been answered yet
  var statementPreviewAjaxInProgress = false;
  // Clear AJAX progress if 'mouseleave' event is triggered before AJAX callback
  var statementPreviewAjaxInProgressCleared = false;
  // DOM ready
  $(function () {
    $('.component-key-preview').toggleItem({
      items: '.component-key-preview__content',
      button: '.component-key-preview__link',
      content: '.component-key-preview__content',
      initial: false,
      closeOnBlur: true,
    });

    $('.questionnaire__component-statements')
    // Mouseover the component statement's preview icon
        .on('mouseenter', '.component-statement__preview-icon', function (e) {
          if (false === statementPreviewAjaxInProgress) {
            var componentCompletionText = null;
            var $componentCompletion = $('.component-completion__form-field-textrespondent');
            if (true === $componentCompletion.find('.form__field--inplace-editable').hasClass('editable-open')) {
              componentCompletionText = $componentCompletion.find('.editable-input input[type=text]').val();
            }
            var $statement = $(this).parents('.component-statement__respondent');
            var $previewContainer = $statement.find('.component-statement__preview');
            // Is the in-place-edit field open?
            var $inPlaceField = $statement.find('.editable-input input[type=text]');
            var inPlaceActive = 0 < $inPlaceField.length;
            statementPreviewAjaxInProgress = true;
            statementPreviewAjaxInProgressCleared = false;
            U.ajax('admin', 'fragebogen-frage-vorschau', {
              statementId: U.elemData(this, 'sid'),
              statementText: true === inPlaceActive && $inPlaceField.val() || null,
              componentCompletionText: componentCompletionText
            }, {
              statusCode: {
                200: function (data, textStatus, jqXHR) {
                  if (false === statementPreviewAjaxInProgressCleared) {
                    $previewContainer
                        .find('.component-statement-preview__content')
                        .html(data)
                        .end()
                        .toggleItem('activate');
                  } else {
                    statementPreviewAjaxInProgressCleared = false;
                  }
                  statementPreviewAjaxInProgress = false;
                }
              }
            });
          } else {
          }
        })
        .on('mouseleave', '.component-statement__preview-icon', function (e) {
          var $statement = $(this).parents('.component-statement__respondent');
          var $previewContainer = $statement.find('.component-statement__preview');
          if (true === statementPreviewAjaxInProgress)
          {
            statementPreviewAjaxInProgressCleared = true;
          }
          $previewContainer.toggleItem('deactivate');
        });
    $('body').on('click', 'a[data-action="questionnaire-add-component"]', function (e) {
      var componentDomainId = Util.elemData(this, 'did');
      var palletId = Util.elemData(this, 'pid');
      var questionnaireId = Util.elemData(this, 'qid');
      var $this = $(this);
      e.preventDefault();
      Util.ajax('admin', 'fragebogen-baustein-hinzufuegen', {
        palletId: palletId,
        questionnaireId: questionnaireId,
        componentDomainId: componentDomainId
      }, {
        statusCode: {
          // Component created?
          201: function (data, textStatus, jqXHR) {
            componentRemoveActiveClass();
            loadComponentTypes(questionnaireId, data.componentId);
            loadComponentTitle(questionnaireId, data.componentId);
            loadComponentCompletion(questionnaireId, data.componentId);
            loadComponentStatements(questionnaireId, data.componentId);
            $('#component-domain-' + componentDomainId).replaceWith(data.renderedHtml);
          }
        }
      })
    });
    $('body').on('click', 'button[data-action="questionnaire-add-component-domain"]', function (e) {
      var palletId = Util.elemData(this, 'pid');
      var questionnaireId = Util.elemData(this, 'qid');
      e.preventDefault();
      Util.ajax('admin', 'fragebogen-bereich-hinzufuegen', {
        palletId: palletId,
        questionnaireId: questionnaireId,
      }, {
        statusCode: {
          // Component created?
          201: function (data, textStatus, jqXHR) {
            loadComponentTypes(questionnaireId, data.componentId);
            loadComponentTitle(questionnaireId, data.componentId);
            loadComponentCompletion(questionnaireId, data.componentId);
            loadComponentStatements(questionnaireId, data.componentId);
            $('.questionnaire__sidebar').html(data.renderedHtml);
          }
        }
      })
    });
    $('body').on('click', 'button[data-action="questionnaire-add-component-statement"]', function (e) {
      var questionnaireId = Util.elemData(this, 'qid');
      var componentId = Util.elemData(this, 'cid');
      e.preventDefault();
      Util.ajax('admin', 'fragebogen-baustein-frage-hinzufuegen', {
        questionnaireId: questionnaireId,
        componentId: componentId
      }, {
        statusCode: {
          // ComponentStatement created?
          201: function (data, textStatus, jqXHR) {
            insertStatements(data);
          }
        }
      })
    });
    // delete ComponentStatement
    $('body').on('click', 'button[data-action="questionnaire-delete-component-statement"]', function (e) {
      var questionnaireId = Util.elemData(this, 'qid');
      var componentStatementId = Util.elemData(this, 'id');
      e.preventDefault();
      Util.ajax('admin', 'fragebogen-baustein-frage-loeschen', {
        questionnaireId: questionnaireId,
        componentStatementId: componentStatementId
      }, {
        statusCode: {
          // Component created?
          200: function (data, textStatus, jqXHR) {
            insertStatements(data);
          }
        }
      })
    });
    // delete Component
    $('body').on('click', 'button[data-action="questionnaire-delete-component"]', function (e) {
      var questionnaireId = Util.elemData(this, 'qid');
      var componentId = Util.elemData(this, 'id');
      e.preventDefault();
      Util.ajax('admin', 'fragebogen-baustein-loeschen', {
        questionnaireId: questionnaireId,
        componentId: componentId
      }, {
        statusCode: {
          // Component created?
          200: function (data, textStatus, jqXHR) {
            var componentDomainId = data.componentDomainId;
            loadComponentTypes(questionnaireId, data.componentId);
            loadComponentTitle(questionnaireId, data.componentId);
            loadComponentCompletion(questionnaireId, data.componentId);
            loadComponentStatements(questionnaireId, data.componentId);
            $('#component-domain-' + componentDomainId).replaceWith(data.renderedHtml);
          }
        }
      })
    });
    // delete ComponentDomain
    $('body').on('click', 'button[data-action="questionnaire-delete-component-domain"]', function (e) {
      var questionnaireId = Util.elemData(this, 'qid');
      var componentDomainId = Util.elemData(this, 'id');
      e.preventDefault();
      Util.ajax('admin', 'fragebogen-bereich-loeschen', {
        questionnaireId: questionnaireId,
        componentDomainId: componentDomainId
      }, {
        statusCode: {
          // Component created?
          200: function (data, textStatus, jqXHR) {
            loadComponentTypes(questionnaireId, data.componentId);
            loadComponentTitle(questionnaireId, data.componentId);
            loadComponentCompletion(questionnaireId, data.componentId);
            loadComponentStatements(questionnaireId, data.componentId);
            $('.questionnaire__sidebar').html(data.renderedHtml);
          }
        }
      })
    });
    var componentTypeCreateTabs = function ($container) {
      // Calculate active tab
      var tabActive = 0;
      // is tab enabled or disabled
      var tabDisabled = $container
          .find('.component-type-select__options')
          .hasClass('component-type-select__options--deactivated');

      $container
        .find('.component-type-select__option')
        .each(function (idx, elem) {
          if (true === $(elem).hasClass('component-type-select__option--active')) {
            tabActive = idx;
            return;
          }
        });
      // Register jQueryUI tabs
      $container
        .find('.component-type-select--tabs')
        .tabs({
          disabled: tabDisabled,
          active: tabActive,
          // Tab is changed
          beforeActivate: function (event, ui) {
            U.ajax('admin', 'fragebogen-baustein-typ-aktualisieren', {
              componentId: ui.newTab.data('cid'),
              questionnaireId: ui.newTab.data('qid'),
              type: ui.newTab.data('option-value'),
              formName: ui.newTab.data('form-name'),
            }, {
              statusCode: {
                200: function (data, textStatus, jqXHR) {
                  // Update UI
                  ui.newTab.find('input[type=radio]').prop('checked', true);
                  ui.newTab.addClass('component-type-select__option--active');
                  ui.oldTab.removeClass('component-type-select__option--active');
                },
                400: function () {
                }
              }
            });
          }
        });
    };
    var componentRemoveActiveClass = function () {
      $('.questionnaire-component__items').find('.questionnaire-component__item--active').removeClass('questionnaire-component__item--active');
    };
    var componentSetActiveClass = function ($component) {
      componentRemoveActiveClass();
      $component.closest('.questionnaire-component__item').addClass('questionnaire-component__item--active');
    };
    var loadComponentTypes = function (questionnaireId, componentId) {
      U.ajax('admin', 'fragebogen-baustein-typ-auswahl', {
        questionnaireId: questionnaireId,
        componentId: componentId
      }, {
        success: function (data, textStatus, jqXHR) {
          var $container = $('.questionnaire__question-header');
          // Insert HTML from AJAX response
          $container.html(data);
          // Create tabs
          componentTypeCreateTabs($container);
        }
      });
    };
    var loadComponentTitle = function (questionnaireId, componentId) {
      U.ajax('admin', 'fragebogen-baustein-titel', {
        questionnaireId: questionnaireId,
        componentId: componentId
      }, {
        success: function (data, textStatus, jqXHR) {
          var $container = $('.questionnaire__component-title-form');
          // Insert HTML from AJAX response
          $container.html(data);
        }
      });
    };
    var loadComponentCompletion = function (questionnaireId, componentId) {
      U.ajax('admin', 'fragebogen-baustein-vervollstaendigung', {
        questionnaireId: questionnaireId,
        componentId: componentId
      }, {
        success: function (data, textStatus, jqXHR) {
          var $container = $('.questionnaire__component-completion');
          // Insert HTML from AJAX response
          $container.html(data);
          initTogglingForComponentCompletion();
        }
      });
    };
    var insertStatements = function (html) {
      $('.questionnaire__component-statements').html(html);
      // Re-init toggling of statement preview
      Toggle.init();
      Questionnaire.initShownEvent();
    };
    var loadComponentStatements = function (questionnaireId, componentId) {
      U.ajax('admin', 'fragebogen-baustein-fragen', {
        questionnaireId: questionnaireId,
        componentId: componentId
      }, {
        success: function (data, textStatus, jqXHR) {
          insertStatements(data);
        }
      });
    };
    var initTogglingForComponentCompletion = function () {
      $('.component-completion').toggleItem({
        items: '.component-completion__body',
        button: '.component-completion__head',
        content: '.component-completion__body',
        initial: false,
        closeOnBlur: false,
      });
    };
    // Create tabs for component rendered on page load
    componentTypeCreateTabs($('.questionnaire__question-header'));
    // Handle click on component in left sidebar
    $('body').on('click', '.questionnaire--edit-form .component__title a', function (e) {
      var $this = $(this);
      e.preventDefault();
      var questionnaireId = U.elemData($(this), 'qid');
      var componentId = U.elemData($(this), 'cid');
      loadComponentTypes(questionnaireId, componentId, $this);
      loadComponentTitle(questionnaireId, componentId);
      loadComponentCompletion(questionnaireId, componentId);
      loadComponentStatements(questionnaireId, componentId);
      componentSetActiveClass($this);
    });

    // toggle script to open component completion
    initTogglingForComponentCompletion();
  });
})(jQuery, Util);
(function ($) {

  var groupSelected = null;

  function listsRefresh() {
    var $lists = $('body')
      .find('.spss-lists-wrapper');

    Util.ajax('admin', 'spss', {
      'case': 'refresh-lists'
    }, {
      success: function (data, textStatus, jqXHR) {
        $lists.replaceWith(data);
      }
    });
  }

  function generateDownloadFile(questionnaireId, $elem) {
    Util.ajax('admin', 'spss', {'case': 'generate', qids: [questionnaireId]}, {
      statusCode: {
        201: function (data, textStatus, jqXHR) {
          listsRefresh();
        },
        500: function (data, textStatus, jqXHR) {
          alert('Es ist ein Fehler aufgetreten.'); // todo: improve ux
        }
      }
    });
    // Notify "In progress..."
    $elem.parents('.spss').find('.spss__toggle').toggleClass('spss__toggle--hidden');
  }

  $(function () {
    // Handle click on "Generate" link
    $('body').on('click', '.spss__action--generate', function (e) {
      e.preventDefault();
      var qid = $(this).data('qid') || null;
      if (null !== qid) {
        generateDownloadFile(qid, $(this));
      }
    });

    // Handle batch generation
    $('.spss-filter').on('click', 'input[type=submit]', function (e) {
      e.preventDefault();
      $('.spss-list')
        .find('input[type=checkbox]:checked')
        .each(function (idx, elem) {
          generateDownloadFile($(elem).val(), $(elem));
        });
    });

    $('.spss-filter__items')
      .on('click', 'a', function (e) {

        var a = $(this),
          groupToSelect = a.data('select');

        e.preventDefault();

        $('.spss-list li:not(.in-progress)')
          .each(function (idx, elem) {

            var selectBy = $(elem).data('select-by') && $(elem).data('select-by').split(' ') || [],
              checkbox = $(elem).find('input[type=checkbox]');

            if (groupToSelect !== groupSelected) {

              if (-1 !== selectBy.indexOf(groupToSelect)) {

                checkbox.prop('checked', true);
              } else {

                checkbox.prop('checked', false);
              }
            } else {

              checkbox.prop('checked', false);
            }
          });

        if (groupToSelect === groupSelected) {

          groupSelected = null;
        } else {

          groupSelected = groupToSelect;
        }

        // Filter
        a
          .parents('.spss-filter__items')
          .find('a')
          .each(function (idx, elem) {
            if ($(elem).data('select') === groupSelected) {
              $(elem).addClass('button--active');
            } else {
              $(elem).removeClass('button--active');
            }
          });
      });
  });

})(jQuery);

(function ($) {
  $(function () {
    $('#filter a.download-csv').click(function () {
      $(this).hide();
    });
  });
})(jQuery);
(function ($) {
  $(function () {
    $('.statisticbrick').tablesorter({
      // Sort by 'Surveys completed' count descending
      sortList: [[1, 1]],
      // Enable use of the 'characterEquivalents' reference (see
      // https://mottie.github.io/tablesorter/docs/example-locale-sort.html)
      sortLocaleCompare: true
    });
  });
})(jQuery);
(function ($) {

  $('.page__header').toggleItem({
    items: '.menu--service, .menu--mainnavigation, .menu--external-main, .menu--usernavigation',
    button: '.header__burger',
    content: '.menu--service, .menu--mainnavigation, .menu--external-main, .menu--usernavigation',
    initial: false,
    closeOnBlur: true,
  });


})(jQuery);

(function ($) {

  $('.header').toggleItem({
    items: '.menu--service, .menu--mainnavigation, .menu--external-main, .menu--external-unterricht, .menu--usernavigation',
    button: '.header__burger',
    content: '.menu--service, .menu--mainnavigation, .menu--external-main, .menu--external-unterricht, .menu--usernavigation',
    initial: false,
    closeOnBlur: true,
  });

})(jQuery);

(function ($) {

  $('.comparative-values__item').toggleItem({
    items: '.comparative-values__item',
    button: '.comparative-values__item-title',
    content: '.comparative-values__item-content',
    initial: true,
    closeOnBlur: false,
  });


})(jQuery);
jQuery(document).ready(function (e) {
  Questionnaire.initXeditable();
  Questionnaire.initShownEvent();
  Questionnaire.toggleArchive();
  Questionnaire.toggleActions();

  // to show key for questionnaire configuration
  $('.form__field--key-introtext, .form__field--key-heading1, .form__field--key-heading2, .form__field--key-header').mouseenter(function () {
    $('.form__description-image').show();
  });

  // to hide key for questionnaire configuration
  $('.form__field--key-introtext, .form__field--key-heading1, .form__field--key-heading2, .form__field--key-header').mouseleave(function () {
    $('.form__description-image').hide();
  });
});

// Questionnaire functions
var Questionnaire = Questionnaire || {};

Questionnaire.toggleArchive = function() {
  // toggle questionnaire archive
  $('.questionnaire-list').toggleItem({
    items: '.questionnaire-list__items',
    button: '.questionnaire-list__headline--archive',
    content: '.questionnaire-list__items',
    initial: false,
    closeOnBlur: false,
  });
};

Questionnaire.toggleActions = function() {
  // toggle questionnaire archive
  $('.questionnaire-list__item-actions').toggleItem({
    items: '.questionnaire-list__action-list',
    button: '.questionnaire-list__action-more',
    content: '.questionnaire-list__action-list',
    initial: false,
    closeOnBlur: true,
  });
};

Questionnaire.initXeditable = function() {
  // https://github.com/vitalets/x-editable/issues/215
  var inplaceEditable = $('body');
  inplaceEditable.editable(
      {
        selector: '.form__field--inplace-editable',
        emptytext: '',
        onblur: 'submit',
        saveonchange: true,
        ajaxOptions: {
          type: 'post',
          dataType: 'json',
        },
        params: function (params) {

          var p = {};
          // neccessary for form validation
          p[params.name] = params.value;
          // send parameters to server
          p.lang = Util.getLocale();
          p.site = Util.getSite();
          p.action = $(this).data('action');
          p.module = $(this).data('module');
          p.p = Util.getDataAttributesOfObject($(this).data(), params);

          return p;
        },
        success: function (response) {
          if (response.container == 'sidebar') {
            var $container = $('.questionnaire__sidebar');
            // Insert HTML from AJAX response
            $container.html(response.data);
          }
        },
        error: function (response) {
          return response.responseText;
        }
      }
  );
};

// adds active class to parent to fix style issue with whitespace: no-wrap and
// overflow:hidden on component statements with preview icon
Questionnaire.initShownEvent = function () {
  $('.form__field--inplace-editable').on('shown', function (e) {
    var componentStatement = $(this).closest('.component-statement__form-field');
    componentStatement.addClass('component-statement__form-field--active');
    componentStatement.focusout(function() {
      $('.component-statement__form-field--active').removeClass('component-statement__form-field--active');
    });
  })
};

(function ($) {

  // activate inline mode
  $.fn.editable.defaults.mode = 'inline';

  //defaults
  $.fn.editable.defaults.url = '/ajax.php';

  // send data always to the server
  $.fn.editable.defaults.send = "always";

  // extend default form template
  $.fn.editableform.template =
      '<form class="form-inline editableform form-inplace__editableform">' +
      '<div class="control-group form-inplace__control-group">' +
      '<div class="editable-input"></div>' +
      '<div class="editable-buttons form-inplace__buttons"></div>' +
      '<div class="editable-error-block form-inplace__editable-error-block"></div>' +
      '</div>' +
      '</form>';

  // custom buttons
  $.fn.editableform.buttons =
      '<button type="submit" class="editable-submit button button--inplace button--inplace-submit"></button>' +
      '<button type="button" class="editable-cancel button button--inplace button--inplace-cancel"></button>';

})(jQuery);
(function ($) {
  // DOM ready
  $(function () {

    $('.menu--service').toggleGroup({
      items: '.login__service',
      button: '.button--login, .button--tan-login',
      content: '.login__service-body',
      initial: false,
      closeOnBlur: true,
    });

    // is now obsolete and can be removed in feature releases
    // use data attributes
    $('.button_open--tan-login').click(function (e) {
      e.stopPropagation();
      var $tanLogin = $('.menu__item--last .login__service');

      // scroll to tan login
      var scrollToTanLogin = typeof $tanLogin[1] !== 'undefined' ? $tanLogin[1].length && $tanLogin.offset().top : null;
      scrollToTanLogin = (null === scrollToTanLogin && typeof $tanLogin[0] !== 'undefined') ? $tanLogin[0].length && $tanLogin.offset().top : null;
      $('html, body').animate({
        scrollTop: scrollToTanLogin,
      }, 600);

      // trigger click event on burger icon
      $('.header__burger').trigger('click');

      // open tan login
      $tanLogin.toggleItem('activate');
      // set focus to tan input
      $('input[name="login_tan"]').focus();
    });
    // set focus for first element
    $('.button--login').click(function () {
      if (true === $(this).hasClass('toggle-item__button--active')) {
        $(this).parents('.login__service').find('input:first').focus();
      }
    });

    $('[data-action="tan-login"]').click(function (e) {
      e.stopPropagation();
      var $tanLogin = $('.menu__item--last .login__service');

      // scroll to tan login
      var scrollToTanLogin = typeof $tanLogin[1] !== 'undefined' ? $tanLogin[1].length && $tanLogin.offset().top : null;
      scrollToTanLogin = (null === scrollToTanLogin && typeof $tanLogin[0] !== 'undefined') ? $tanLogin[0].length && $tanLogin.offset().top : null;
      $('html, body').animate({
        scrollTop: scrollToTanLogin,
      }, 600);

      // trigger click event on burger icon
      $('.header__burger').trigger('click');

      // open tan login
      $tanLogin.toggleItem('activate');
      // set focus to tan input
      $('input[name="login_tan"]').focus();
    });

    $('[data-action="user-login"]').click(function (e) {
      e.stopPropagation();
      var $userLogin = $('.menu__item--user-login .login__service');

      // scroll to tan login
      var scrollTo = typeof $userLogin[1] !== 'undefined' ? $userLogin[1].length && $userLogin.offset().top : null;
      scrollTo = (null === scrollTo && typeof $userLogin[0] !== 'undefined') ? $userLogin[0].length && $userLogin.offset().top : null;
      $('html, body').animate({
        scrollTop: scrollTo,
      }, 600);

      // trigger click event on burger icon
      $('.header__burger').trigger('click');

      // open tan login
      $userLogin.toggleItem('activate');
      // set focus to tan input
      $('input[name="login_lehrer_email"]').focus();
    });

  });
})(jQuery);

// do some magic for the unterricht menu
// remove targets and links
jQuery(document).ready(function (e) {
    $('.menu--external-unterricht').each(function (index) {
        $(this).children().each(function (key) {
            if (key == 0 || key == 1) {
                var link = $(this).find('a');
                if (link.length == 1) {
                    link.removeAttr('target');
                }
            }
            if (key == 1) {
                var link = $(this).find('a');
                if (link.length == 1) {
                    link.removeAttr('href').attr('href', '#');
                }
            }
        })
    });
});

(function ($) {
  $('[data-modal="state"]').on('change', function() {
    if ($(this).is(':checked')) {
      $('body').addClass('modal--open');
    } else {
      $('body').removeClass('modal--open');
    }
  });

  $('body').on('click', '.modal__container, .modal--close', function() {
    $('.modal__state:checked').prop('checked', false).change();
  });

  $('body').on('click', '.modal__content', function(event) {
    event.stopPropagation();
  });

  $('body').on('click', '[data-action="cancel"]', function(event) {
    $('.modal__state:checked').prop('checked', false).change();
  });

  $('body').on('click', '[data-url]', function(event) {
    event.stopPropagation();
    window.location.href = $(this).data('url');
  });
})(jQuery);
(function ($) {

  $(function () {

    // Vorschau auf Anrede generieren (Formular S. 2)
    $('input[name=name], select[name=anrede]').on('change keyup', function () {
      address_preview();
    });

    address_preview();

    // Geschaetzte Antwortdauer berechnen
    components_selected_update();

    // Anzahl angewaehlter Konstrukte in verstecktes Feld schreiben
    $('.survey__form--questionnaire').on('change', 'input[name="konstrukte[]"], input[name^="standardKonstruktMengen["], input[name="fragebogen[]"], input[data-section^="section-"]', function (e) {
      components_selected_update();
    });

    // JS-Loesung fuer Textbereich, falls kein HTML5 unterstuetzt wird
    $('.survey__form--questionnaire').on('input propertychange', '[data-text-maxlength]', function () {

      var max = $(this).data('text-maxlength'),
          chars = $(this).val().length;

      if (chars > max) {
        $(this).val($(this).val().substring(0, max));
      }
    });

    // Standard-Text in Textfeldern fuer "Eigene Fragestellungen"
    $('.survey__form--questionnaire').on('blur', '[data-text-default]', function () {

      var value = $(this).val(),
          text_default = $(this).data('text-default');

      if ('string' === typeof value && 0 === value.length
          && 'string' === typeof text_default && 0 < text_default.length) {

        $(this)
            .val(text_default)
            .addClass('txt-hint');
      }
    });

    $('.survey__form--questionnaire').on('focus', '[data-text-default]', function () {

      var value = $(this).val(),
          text_default = $(this).data('text-default');

      if ('string' === typeof value && 'string' === typeof text_default && value === text_default) {

        $(this)
            .val('')
            .removeClass('txt-hint');
      }
    });

    // ... auch beim Laden der Seite
    // statements_text_default_toggle();

    // Bei Klick auf "Weiter" Standardwerte (Hilfetext) entfernen
    $('.survey__form--questionnaire').on('click', 'input[name=do_next]', function () {

      $(this)
          .parents('form')
          .find('[data-text-default]')
          .each(function (idx, elem) {

            var value = $(elem).val(),
                text_default = $(elem).data('text-default');

            if ('string' === typeof value && 'string' === typeof text_default && value === text_default) {

              $(this).val('');
            }
          });
    });
  });

  // Vorschau auf Anrede
  function address_preview() {

    var anrede_element = jQuery("[name=anrede]");
    var name_element = jQuery("[name=name]");
    var anrede = anrede_element.val();
    var name = name_element.val(),
        preview = $('#previewtxt');

    // Nur auf Seite mit Vorschau-Feld
    if (0 === preview.length) {
      return;
    }

    var locale = '';
    if (preview.attr('data-i18n-locale').match(/([a-z]{2}_[A-Z]{2})/g)) {
      locale = RegExp.$1;
    }

    Util.ajax('befragung', 'neu', {
      step: 'address',
      t: jQuery('input[name=t]').val(),
      umfragetyp: jQuery('input[name=umfragetyp]').val(),
      anrede: anrede,
      name: name,
      perspective: 2,
      locale: locale
    }, {
      success: function (r) {

        if (false === r.error) {
          $('#previewtxt').html(r.data.text);
        }
      }
    });
  }

})(jQuery);

// Geschaetzte Ausfuelldauer aktualisieren
function duration_update(q) {

  if (0 === $('span#fragen').length) {
    return;
  }

  if (0 < q) {

    // Geschaetzte Dauer per Ajax ermitteln
    Util.ajax('befragung', 'neu', {
      // Bemerkung: Parameter "Klassenstufe" wird per Util.ajaxSetParam(2)
      // aus Modul heraus hinzugefuegt
      step: 'questionnaire',
      action: 'response_time',
      questions: q
    }, {
      success: function (r) {

        if (false === r.error) {
          $('span#fragen').html(q);
          $('span#minuten').html(r.data.duration);
        }
      }
    });
  }
  // 0 Fragen
  else {
    $('span#fragen').html(q);
    $('span#minuten').html(0);
  }
}


function components_selected_update() {

  var q = 0,
      k = 0;

  $('input[name="konstrukte[]"]').each(function (idx, elem) {

    if ($(elem).is(':checked')) {
      q += $(this).data('itanz');
      k++;
    }
  });

  duration_update(q);

  $('input[name=konstrukte_befragung]').val(k);
}

function schritt3SelectStandardSet(fbid, standardset, checked) {

  var konstrukte = jQuery('[name="konstrukte[]"]');
  konstrukte.each(function (i, konstrukt) {
    var konstrukt = $(konstrukt);
    if (fbid == konstrukt.attr("data-fbid") && standardset == konstrukt.attr("data-kstandard")) {
      konstrukt.prop("checked", checked);
      var databrick = konstrukt.attr('data-brick');
      $('[data-section="'+databrick+'"]').prop("checked", checked);
    }
  });
}

function selectSectionSet(e) {
  var target = jQuery(e.currentTarget);
  var section = target.attr("data-section");
  var checked = target.is(":checked");

  var bricks = jQuery('[data-brick="'+section+'"');

  bricks.each(function (i, brick) {
    $(brick).prop("checked", checked);
  });

}

function schritt3SelectStandardSetHandler(e) {

  var target = jQuery(e.currentTarget);
  var fbid = target.attr("data-fbid");
  var standardset = target.attr("value");
  var checked = target.is(":checked");

  schritt3SelectStandardSet(fbid, standardset, checked);
}

function schritt3SelectFragebogenHandler(e) {

  var target = jQuery(e.currentTarget);
  var fbid = target.attr("data-fbid");
  var checked = target.is(":checked");
  var standardsets = jQuery('[name="standardKonstruktMengen[' + fbid + '][]"]');

  standardsets.each(function (i, standardsetElement) {
    var standardsetElement = jQuery(standardsetElement);
    var standardset = standardsetElement.attr("value");
    standardsetElement.prop("checked", checked);
    schritt3SelectStandardSet(fbid, standardset, checked);
  });

}

jQuery(function (e) {

  // set focus to first form element
  jQuery('[name="anrede"]').focus();

  // select questionnaire
  jQuery('input[name^="standardKonstruktMengen["]').change(schritt3SelectStandardSetHandler);

  // choose complete questionnaire
  jQuery('input[name="fragebogen[]"]').change(schritt3SelectFragebogenHandler);

  // choose complete questionnaire
  jQuery('input[data-section^="section-"]').change(selectSectionSet);

});

(function ($) {

  jQuery("body").find(".survey__description--nojs").hide();

})(jQuery);
(function ($) {

  statements_selection_options_toggle();
  addTogglefFunctionalityToDynamicAccordionContent(false);

  // accordion for questionnaires
  $('.form__questionnaire-items').toggleGroup({
    items: '.form__questionnaire-item',
    button: '.form__questionnaire-item--toggle',
    content: '.form__questionnaire-item-body',
    initial: false,
    closeOnBlur: false,
  });

  // accordion design selection
  $('.survey__form--questionnaire-design').toggleItem({
    button: '.survey__form-select-design',
    content: '.form__designtemplates-items',
    initial: false,
    closeOnBlur: false,
  });

  // Klick auf Button "Aussage hinzufuegen"
  // Bemerkung: Klick wird delegiert, da der Button als Ergebnis des
  // Ajax-Aufrufs (wie auch das ganze Formular) ersetzt wird und damit das
  // gebundene Event ebenfalls verloren ginge
  $('.survey__form--questionnaire').on('click', 'button[name="bar"], button[name="bazzz"]', function (e) {

    var form_name = $(this).parents('form').attr('name'),
        form = $('form[name=' + form_name + ']'),
        form_data,
        form_statements,
        form_fields = ['konstrukttypen', 'aussagen_fragesteller', 'aussagen_teilnehmer'],
        form_components; // Konstrukte aus ISQ-Frageboegen

    e.preventDefault();

    // Noch nicht gesendete Formulareingaben uebernehmen
    form_statements = form_get_data(form_name, form_fields);

    // Konstrukte
    form_components = form_get_data(form_name, ['konstrukte']);

    // reopen toggle item after adding new content mask
    $prevElement = $(this).closest('.form__item').prev();
    prevElementId = null;
    if ($prevElement.attr('id')) {
      prevElementId = $prevElement.attr('id');
    }

    if ('bar' == $(this).attr('name')) {
      var initial = '.form__questionnaire-additional-modules--singlechoice';
    } else {
      var initial = '.form__questionnaire-additional-modules--freetext';
    }

    form_data = {
      t: form_statements['konstrukttypen'],
      q: form_statements['aussagen_fragesteller'],
      r: form_statements['aussagen_teilnehmer'],
      c: form_components['konstrukte']
    };

    Util.ajax('befragung', 'neu', {
      step: 'questionnaire',
      action: 'statement_add',
      form: form_name,
      form_data: form_data,
      init: $(this).attr('name')
    }, {
      success: function (r) {

        if (false === r.error) {
          $form = $('form[name=' + form_name + ']');
          $form.replaceWith(r.data.form);
          statements_selection_options_toggle();
          addTogglefFunctionalityToDynamicAccordionContent(initial);
        }
      },
      complete: function () {
        if (null !== prevElementId) {
          $prevElement = $("#"+prevElementId).next();
        } else {
          $prevElement = $('.form__questionnaire-additional-modules-body.toggle-item__content--active').find('.form__questionnaire-ownquestion');
        }

        $('html, body').animate({
          scrollTop: $prevElement.offset().top
        }, 0);
      }
    });
  });

  // Aussage entfernen
  $('.survey__form--questionnaire').on('click', '.form__questionnaire-ownquestion-delete', function (e) {

    var form_name = $(this).parents('form').attr('name'),
        form_fields = ['konstrukttypen', 'aussagen_fragesteller', 'aussagen_teilnehmer'],
        form_data,
        form_statements,
        form_components, // Konstrukte aus ISQ-Frageboegen
        fieldset = $(this).parents('div[id^="fieldset-"]'),
        fieldset_id = fieldset.attr('id');

    e.preventDefault();
    $prevElement = $(this).closest('.form__questionnaire-ownquestion').prev();
    prevElementId = null;
    if ($prevElement.attr('id')) {
      prevElementId = $prevElement.attr('id');
    }

    // Formulardaten (Aussagen) zusammenstellen
    form_statements = form_get_data(form_name, form_fields);

    // Konstrukte
    form_components = form_get_data(form_name, ['konstrukte']);

    // reopen toggle item after remove statement
    if (true === $(this).parents('.form__questionnaire-additional-modules').hasClass('form__questionnaire-additional-modules--singlechoice')) {
      var initial = '.form__questionnaire-additional-modules--singlechoice';
    } else {
      var initial = '.form__questionnaire-additional-modules--freetext';
    }

    form_data = {
      t: form_statements['konstrukttypen'],
      q: form_statements['aussagen_fragesteller'],
      r: form_statements['aussagen_teilnehmer'],
      c: form_components['konstrukte']
    };

    Util.ajax('befragung', 'neu', {
      step: 'questionnaire',
      action: 'statement_delete',
      form: form_name,
      form_data: form_data,
      fid: fieldset_id
    }, {
      success: function (r) {
        if (false === r.error) {
          $form = $('form[name=' + form_name + ']');
          $form.replaceWith(r.data.form);
          statements_selection_options_toggle();
          addTogglefFunctionalityToDynamicAccordionContent(initial);
        }
      },
      complete: function () {
        if (null !== prevElementId) {
          $prevElement = $("#"+prevElementId);
        } else {
          $prevElement = $('.form__questionnaire-additional-modules-body.toggle-item__content--active');
        }
        $('html, body').animate({
          scrollTop: $prevElement.offset().top
        }, 0);
      }
    });
  });


  function form_get_data(name, fields) {

    var form = $('form[name=' + name + ']'),
        form_data = {},
        field_indexes = [];

    // Rueckgabe initialisieren
    $.each(fields, function (idx, field_name) {
      form_data[field_name] = [];
    });

    form.find('input, select, textarea').each(function (idx1, field) {

      var field = $(field);

      $.each(fields, function (idx, field_name) {

        var regex = new RegExp(field_name + '\\[([0-9]*)\\]'),
            index, // Index im Daten-Array (Formularfeld)
            field_value;

        // Feld per Name identifiziert?
        if ('string' === typeof field.attr('name') && field.attr('name').match(regex)) {

          field_value = '';
          index = RegExp.$1;

          // Standard-Wert (Hilfetext) ignorieren
          if ('string' !== typeof field.data('text-default') || field.val() !== field.data('text-default')) {
            field_value = field.val();
          }

          // Bei Radio-Buttons und Checkboxes nur den Wert des angewaehlten
          // Buttons uebernehmen
          if ('radio' !== field.attr('type') && 'checkbox' !== field.attr('type')
              || true === field.is(':checked')) {

            // Fuer Felder ohne konkrete Indizierung Index selbst "generieren"
            if (0 === index.length) {

              if (undefined === field_indexes[field_name]) {
                field_indexes[field_name] = 0;
              }
              index = field_indexes[field_name]++;
            }

            form_data[field_name][index] = field_value;
          }
        }
      });
    });

    return form_data;
  }


  function addTogglefFunctionalityToDynamicAccordionContent(initial) {
    $('.form__questionnaire-additional-modules').toggleItem({
      items: '.form__questionnaire-additional-modules-content',
      button: '.form__questionnaire-additional-modules-name',
      content: '.form__questionnaire-additional-modules-body',
      initial: initial,
      closeOnBlur: false,
    });
  }

  // Auswahloptionen bei eigener Aussage bestimmen und darstellen,
  // Fuer alle Aussagen mit Mehrfachauswahl die gewaehlten Optionen darstellen
  function statements_selection_options_toggle() {

    // hide not checked options
    $('input[name^="konstrukttypen["]:checked').each(function (idx, elem) {
      selection_options_toggle($(elem).parents('div[id^="fieldset-"]').attr('id'), $(elem).val());
    });

    // add on change trigger to compontes to toggle checked options
    $('.form__questionnaire').on('change', 'div[id^="fieldset-"] input[name^="konstrukttypen["]', function () {
      selection_options_toggle($(this).parents('div[id^="fieldset-"]').attr('id'), $(this).val());
    });
  }

  function selection_options_toggle(fieldset_id, type_id) {
    $('div#' + fieldset_id + ' div[class*="selectoption--option-"]').each(function (idx, elem) {
      var elem = $(elem);

      if (elem.hasClass('selectoption--option-' + type_id)) {
        elem.show();
      }
      else
      {
        elem.hide();
      }
    });
  }

})(jQuery);



(function ($) {

  $(function () {

    // Auswahlfeld "Bundesland"
    var _field_state = state_field_get();

    // Ist die Auswahl "Schulform" verfuegbar? Dies ist z.B. bei der
    // Registrierung von Schulraeten nicht der Fall.
    if (true === school_type_available()) {

      school_type_field_toggle(_field_state.val());

      $('.registration').on('change', 'select[name=bundesland]', function (e) {

        var form = $(this).parents('form'),
            form_name = form.attr('name'),
            state_id = $(this).val(),
            email = form.find('input[name=email]').val(),
            pwd1 = form.find('input[name=password1]').val(),
            pwd2 = form.find('input[name=password2]').val(),
            newsletter = form.find('input[name=newsletter]').is(':checked'),
            terms = form.find('input[name=nutzungsb]').is(':checked');

        Util.ajax('konto', 'registrierung', {
          action: 'school_type_options',
          form: form_name,
          state_id: state_id
        }, {
          success: function (r) {

            var field_state;

            if (false === r.error) {

              form.replaceWith(r.data.form);

              // Formularfelder nach DOM-Manipulation neu bestimmen
              field_state = state_field_get();
              field_state
                  .parents('form')
                  .find('input[name=email]')
                  .val(email)
                  .end()
                  .find('input[name=password1]')
                  .val(pwd1)
                  .end()
                  .find('input[name=password2]')
                  .val(pwd2)
                  .end()
                  .find('input[name=newsletter]')
                  .attr('checked', newsletter)
                  .end()
                  .find('input[name=nutzungsb]')
                  .attr('checked', terms);

              // Feld "Schulform" ggf. deaktivieren
              school_type_field_toggle(state_id);
            }
          }
        });
      })
    }
  });

  function school_type_field_toggle(value) {

    var field = school_type_field_get(),
        field_options = field.children().length,
        option_selected = field.val();

    if (undefined !== value) {
      option_selected = value;
    }

    if (option_selected && 1 < field_options) {
      field.prop('disabled', false);
    }
    else {
      field.prop('disabled', true);
    }
  }

  function state_field_get() {

    var field = null;

    if (true === school_type_available()) {
      // Note: Can be either a select or hidden field
      field = $('form[name^=registrierung]')
          .find('[name=bundesland]');
    }

    return field;
  }

  function school_type_field_get() {

    var field = null;

    if (true === school_type_available()) {
      field = $('form[name^=registrierung]')
          .find('select[name=schulform]');
    }

    return field;
  }

  function school_type_available() {

    var field_count = $('form[name^=registrierung]')
        .find('select[name=schulform]')
        .length;

    return (0 < field_count) ? true : false;
  }

})(jQuery);
(function ($) {

  $('.sidenavigation').toggleItem({
    items: '.menu--sidenavigation, .menu--external-seminarleitung, .menu--external-schulaufsicht, .menu--external-start, .menu--external-schulmanagement, .menu--external-unterricht',
    button: '.menu__title-headline',
    content: '.menu--sidenavigation, .menu--external-seminarleitung, .menu--external-schulaufsicht, .menu--external-start, .menu--external-schulmanagement, .menu--external-unterricht',
    initial: false,
    closeOnBlur: true,
  });


})(jQuery);

(function ($) {
    jQuery(document).ready(function (e) {
        var $body = jQuery('body');
        if ($body.hasClass('action-befragung-ausfuellen') && !(/query-befragung-ausfuellen-\d+-fertig/.test($body.attr('class')))) {
            document.body.onclick = function (e) {
                e = e || event;
                var element = e.target;
                if (element instanceof HTMLAnchorElement || element instanceof HTMLImageElement) {
                    var $element = jQuery(element);
                    if (($element.is('a')  || $element.parent().is('a')) && false === $element.hasClass('button--survey')) {
                        e.preventDefault();
                        var href = $element.attr('href') || $element.parent().attr('href');
                        $buttonLeave = jQuery('[data-action="leave"]');
                        $buttonLeave.attr('data-url', href);
                        jQuery('#modal-survey').trigger('click');
                    }
                }
            }
        }
    })
})(jQuery);

(function ($) {
  jQuery(document).ready(function (e) {

    // get gender from radio list and redirect
    $('[data-action="submit"]').click(function () {
      var genderList = $('.gender');
      var selectedGender = $('input[name="gender"]:checked');
      if (selectedGender.val() && (selectedGender.attr('id') == 1 || selectedGender.attr('id') == 2)) {
        genderList.removeClass('gender--error');
        window.location.href = selectedGender.val();
      } else {
        genderList.addClass('gender--error');
      }
    });

    // set focus on first option element
    var surveyCompletion = $('.survey-complete__form');
    surveyCompletion.find('input[id^="option-"]:first').focus();

    // we need this little hack for ios, cause ios do not recognize an on focus change
    $('input[id^="option-"]').on('click', function () {
      this.focus();
    });

    $('input[id^="option-"]').focus(function () {
      // remove any focus modifier class on tab
      surveyCompletion.find('.survey-complete__form-item--focus').removeClass('survey-complete__form-item--focus');
      // set focus modifier to parent item
      $(this).closest('.survey-complete__form-item').addClass('survey-complete__form-item--focus');
      scrollToNextFocusElement();
    });

    $('button[name="do_respond"]').focus(function () {
      // remove any focus modifier class on tab
      surveyCompletion.find('.survey-complete__form-item--focus').removeClass('survey-complete__form-item--focus');
    });

    // allow option selection via key 1,2,3,4,5
    $('.survey-complete__form-item-option').keyup('input[id^="option-"]', function (event) {
      event.stopPropagation();
      // assign keyboard code to checkbox value
      var keyMap = {
        49: 0,
        97: 0,
        50: 1,
        98: 1,
        51: 2,
        99: 2,
        52: 3,
        100: 3,
        53: 4,
        101: 4
      };
      var key = event.which;
      // key from keymap is triggered
      if (typeof keyMap[key] !== 'undefined') {
        // get focused object
        var focused = $('.survey-complete__form-item--focus');
        if (focused.hasClass('survey-complete__form-item')) {
          // check if checkboxes exist in focused object/question
          var checkboxes = focused.find('input[id^="option-"]');
          // check checkbox used with key
          $.each(checkboxes, function (index) {
            if (index === keyMap[key]) {
              var $this = $(this);
              $this.prop('checked', true).focus().change();
            }
          });
        }
      }
    });

    var scrollToNextFocusElement = function () {
      // only scroll on mobile or tablet, bound to media query ($desktop-screen-below)
      if (window.matchMedia("(max-width: 1023px)").matches) {
        $focused = $('.survey-complete__form-item--focus');
        $next = $focused.next();
        // do not scroll on last element
        if ($next.length > 0) {
          var scroll_to_element_top = $next.offset().top;
          scrollToTop(scroll_to_element_top);
        }
      }
    };
    var scrollToTop = function (scroll_to_top) {
      $('html, body').animate({
        scrollTop: scroll_to_top,
      }, 600);
    };

    var scrollToFirstQuestionWithError = function () {
      var statementError = $('.survey-complete__form-item-error');
      if (statementError.length > 0) {
        var scroll_to_element_top = statementError.length && statementError.offset().top - 10;
        scrollToTop(scroll_to_element_top);

        // set focus to first option
        setTimeout(function () {
          var parentElementOfError = statementError[0].closest('.survey-complete__form-item');
          $(parentElementOfError).find('input[id^="option-"]:first').focus();
        }, 10);
      }
    };

    $('input[id^="option-"]').on("change", function () {
      if ($(this).prop("checked")) {
        $(this).parents('.survey-complete__form-item').find('.survey-complete__form-item-error').hide();
      }
    });

    scrollToFirstQuestionWithError();
  })
})(jQuery);

(function ($) {

  $(function () {
    toggleDelivery($('input[name="tan_zustellung"]:checked').val());

    // TAN-Zustellung
    $('input[name="tan_zustellung"]').click(function (e) {
      toggleDelivery($(this).val());
    });
  });

  function toggleDelivery(delivery) {

    var id = (2 === parseInt(delivery, 10)) ? 'empfaenger' : 'anzahl';

    jQuery('.survey__form')
        .find('#form-field-anzahl, #form-field-empfaenger')
        .hide()
        .end()
        .find('#form-field-' + id)
        .show();
  }
})(jQuery);